
<c-contract-editor
    title      = "Wartungsvertrag"
    :unit-data = "unitData"
    @store     = "onStore"
    @edit      = "onEdit"
    @start     = "onStart"
    @end       = "onEnd"
>
    <template v-slot:additional>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2 col-6">
                <f-currency-field-rw
                    class     = "money"
                    :label    = "$t('contract.mnt.costsPerYear')"
                    :readonly = "readonly"
                    v-model   = "unitData.costs"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-2 col-6">
                <f-number-field-rw
                    :label         = "$t('contract.mnt.countPerYear')"
                    v-model        = "unitData.count"
                    :readonly      = "readonly"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>
    </template>
</c-contract-editor>
